import AppRouter from "./routes/AppRouter";

const App = () => <AppRouter />;

export default App;
// This is the main entry point of the application. It imports the AppRouter component and renders it.